module.exports = __webpack_public_path__ + "static/media/tab-2.8bc0dab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/tab-2.png
// module id = 1252
// module chunks = 0